import React from 'react';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Models
import { isRegular } from 'models/cpm/slug';
// Custom
import { listRowSpecsShape, cpmSlugShape } from 'constants/PropTypesShapes';
import { EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import InfoCheckbox from 'components/misc/InfoCheckbox';
import { joinNonEmpty } from 'utils/Tools';

const SlugRow = React.forwardRef(({
  slug, onEdit, onDelete, rowSpecs,
}, ref) => {
  const handleEdit = () => {
    onEdit(slug);
  };

  const handleDelete = () => {
    onDelete(slug);
  };

  return (
    <TableRow
      ref={ref}
      element={slug}
      rowSpecs={rowSpecs}
      actions={[
        <EditIconButton key="bEdit" onClick={handleEdit} />,
        onDelete && isRegular(slug) && <DeleteIconButton key="bDelete" onClick={handleDelete} />,
      ]}
    >
      {/* ----- domain ----- */}
      <TableCell>
        <TruncatedTooltipText>{slug.domain}</TruncatedTooltipText>
      </TableCell>
      {/* ----- slug ----- */}
      <TableCell>
        <TruncatedTooltipText>{slug.slug}</TruncatedTooltipText>
      </TableCell>
      {/* ----- usages ----- */}
      <TableCell>
        <TruncatedTooltipText>{joinNonEmpty(slug.usages, ' ')}</TruncatedTooltipText>
      </TableCell>
      {/* ----- comment ----- */}
      <TableCell>
        <TruncatedTooltipText>{slug.comment}</TruncatedTooltipText>
      </TableCell>

      {/* ----- usedOnPrintedQrCode ----- */}
      <TableCell className="table-content-center">
        <InfoCheckbox value={slug.usedOnPrintedQrCode} />
      </TableCell>
    </TableRow>
  );
});

SlugRow.displayName = 'SlugRow';

SlugRow.propTypes = {
  slug: cpmSlugShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

SlugRow.defaultProps = {
  onEdit: null,
  onDelete: null,
};

module.exports = SlugRow;



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/slug/SlugRow.js